import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withRtl } from '../hoc';

import ButtonAction from '../ButtonAction';
import Checkbox from '../Checkbox';
import CaretDownIcon from '../icons/CaretDown';
import style from './FilterSelect.scss';
import { getPreKIconName, customisedIntlFormatMessage } from '../../utils/helpers';

const messages = defineMessages({
  reset: {
    id: 'filterselect.reset',
    defaultMessage: 'Reset',
    description: 'Reset label',
  },
  apply: {
    id: 'filterselect.apply',
    defaultMessage: 'Apply',
    description: 'Apply Label',
  },
});

class FilterSelect extends PureComponent {
  static defaultProps = {
    selected: 0,
    HSninthGrader: false,
    selectSavedProgramsFilter: false,
    name: 'API ERROR',
    admissionProcess: null,
  };
  static propTypes = {
    apply: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    optionGroups: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            selected: PropTypes.bool,
          }),
        ),
      }),
    ).isRequired,
    reset: PropTypes.func.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string,
      messages: PropTypes.shape({}),
      formatMessage: PropTypes.func,
    }).isRequired,
    selected: PropTypes.number,
    HSninthGrader: PropTypes.bool,
    selectSavedProgramsFilter: PropTypes.bool,
    admissionProcess: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.initialOptionGroups = [...props.optionGroups];
    this.state = {
      open: false,
      filtersUpdated: false,
      optionGroups: [...props.optionGroups],
    };
    const { apply, HSninthGrader, selectSavedProgramsFilter } = this.props;

    if (HSninthGrader || selectSavedProgramsFilter) {
      const { optionGroups } = this.state;
      apply({ optionGroups });
    }
  }

  componentDidUpdate(prevProps) {
    // apply overriden filter on load
    const { apply, HSninthGrader, selectSavedProgramsFilter } = this.props;

    if (prevProps.HSninthGrader !== HSninthGrader && HSninthGrader) {
      const { optionGroups } = this.state;
      apply({ optionGroups });
    }

    if (prevProps.selectSavedProgramsFilter !== selectSavedProgramsFilter && selectSavedProgramsFilter){
      const { optionGroups } = this.state;
      apply({ optionGroups });
    }
  }

  onOptionChange = (groupIndex, optionValue, checked) => {
    const optionGroups = [...this.state.optionGroups];
    const optionGroup = optionGroups[groupIndex];
    const option = optionGroup.options.find(opt => opt.value === optionValue);
    option.selected = checked;
    if (checked) {
      option.true = {
        id: option.value,
        label: option.label,
        section: option.id,
      };
    } else {
      delete option.true;
    }

    this.setState({
      ...this.state,
      optionGroups,
      filtersUpdated: true,
    });
  };

  handleReset = () => {
    const { apply } = this.props;
    const { optionGroups } = this.state;
    const resetOptionGroups = [];
    const urlParams = new URLSearchParams(window.location.search);
    let showSavedProgramsOnly = urlParams.get('saves');
    optionGroups.forEach(optionGroup => {
      optionGroup.options.map(option => {
        const o = option;
        if ((o.true && o.selected && o.id != 'saved_programs') || (o.id == 'saved_programs' && showSavedProgramsOnly != '1')) {
          o.selected = false;
          delete o.true;
        }
      });
      resetOptionGroups.push(optionGroup);
    });

    this.setState({
      ...this.state,
      open: false,
      optionGroups: resetOptionGroups,
    });

    apply({
      optionGroups: resetOptionGroups,
    });
  };

  handleClose = () => {
    const { apply } = this.props;
    const { filtersUpdated, optionGroups } = this.state;

    if (filtersUpdated) {
      apply({ optionGroups });
    }

    this.setState({
      ...this.state,
      open: false,
      filtersUpdated: false,
    });
  };

  handleTabKeyClose = event => {
    // Last focusable element in filter select should call this function on key down
    if (!event.shiftKey && event.key === 'Tab') {
      this.handleClose();
    }
  };

  handleShiftTabKeyClose = event => {
    // First focusable element in filter select should call this function on key down
    if (event.shiftKey && event.key === 'Tab') {
      this.handleClose();
    }
  };

  toggle = () => {
    const isOpen = !this.state.open;

    if (!isOpen) {
      this.handleClose();
    } else {
      this.setState({ open: isOpen });
    }
  };

  numSelected = () => {
    const { selected } = this.props;

    const { optionGroups } = this.state;
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('saves') == '1'){
      optionGroups.forEach(optionGroup => {
        optionGroup.options.map(option => {
          if ((option.id == 'saved_programs')) {
            option.selected = true;
          }
        });
      });
    }

    if (selected < 1) {
      return false;
    }

    /* eslint-disable react/no-danger */
    //return <span dangerouslySetInnerHTML={{ __html: `&nbsp;(${selected})` }} />;
    return <span> ({selected})</span>;
  };

  render() {
    const { label, selected, intl } = this.props;
    const { open, optionGroups } = this.state;
    const buttonClass = classNames(
      style.button,
      { [style.buttonOpen]: open },
      { [style.buttonHighlighted]: !!selected },
    );
    const isPK = window.App.state.user.admissionProcess === 'PK' || this.props.admissionProcess === 'PK';
    const is2K = window.App.state.user.admissionProcess === '2K' || this.props.admissionProcess === '2K';
    const is3K = window.App.state.user.admissionProcess === '3K' || this.props.admissionProcess === '3K';

    return (
      <div className={style.root}>
        <button
          className={buttonClass}
          onClick={this.toggle}
          onKeyDown={this.handleShiftTabKeyClose}
          aria-expanded={this.state.open}
        >
          {label}
          {this.numSelected()}
          {/* <i className="icon-Caret-Down" /> */}
          <CaretDownIcon size={10} fill="#0345a7" />
        </button>
        {open && (
          <div className={style.dropDown}>
            <div className={style.wrap}>
              {optionGroups.map((optionGroup, idx) => (
                <div
                  className={style.group}
                  key={`${optionGroup.id}${optionGroup.label}`}
                  role="group"
                  aria-label={optionGroup.label}
                >
                  <div className={style.label}>{optionGroup.label}</div>
                  {optionGroup.desc && <div className={style.desc}>{optionGroup.desc}</div>}
                  {optionGroup.options.map(option => {
                    // temporarily hide the "10th Grade Seats Available" filter
                    if (option.label === '10th Grade Seats Available') {
                      return '';
                    }

                    let preKIcon;
                    const optionsMap = {
                      'District School': 'District School',
                      'NYC Early Education Center': 'NYCEEC',
                      'Charter School': 'Charter School',
                      'Pre-K Center': 'Pre-K Center',
                      'Half Day Only': 'Half Day',
                      'EarlyLearn 3s': 'Early Learn 3s',
                    };
                    if ((isPK || is2K || is3K) && option.id === 'eligibility') {
                      preKIcon = getPreKIconName([{ name: optionsMap[option.labelEn] }]);
                    }
                    /* key is later used as id in Checkbox and spaces must be replaced because
                    there were problems with screen readers. */
                    const key = `${optionGroup.id}${option.value}${option.label}`.replace(/\s+/g, '-');
                    const onChange = event => {
                      this.onOptionChange(idx, option.value, event.currentTarget.checked, option.label);
                    };
                    let disableFilter = false;
                    if (option.id === 'saved_programs'){
                      const urlParams = new URLSearchParams(window.location.search);
                      let showSavedProgramsOnly = urlParams.get('saves');
                      if (showSavedProgramsOnly == '1'){
                        option.selected = true;
                        disableFilter = true;
                      }
                    }

                    return (
                      <Checkbox
                        key={key}
                        id={key}
                        value={option.value}
                        checked={option.selected}
                        label={option.label}
                        onChange={onChange}
                        icon={preKIcon}
                        disabled={disableFilter}
                        disabledForSavedPrograms={disableFilter}
                        // filterName={name}
                      />
                    );
                  })}
                </div>
              ))}
            </div>
            <footer className={style.footer}>
              <button className={style.reset} onClick={this.handleReset}>
                <FormattedMessage {...messages.reset} />
              </button>
              <ButtonAction
                onClick={this.handleClose}
                onKeyDown={this.handleTabKeyClose}
                icon="Check"
                aria-label={customisedIntlFormatMessage(intl, messages.apply)}
                label={customisedIntlFormatMessage(intl, messages.apply)}
                small
              />
            </footer>
          </div>
        )}
        {open && <div className={style.modalBackground} role="presentation" onClick={this.toggle} />}
      </div>
    );
  }
}

export { FilterSelect };
export default withRtl(style)(withStyles(style)(injectIntl(FilterSelect)));
